import React from 'react';
import { connect } from 'dva';
import { Button, Row, Col } from 'antd';

import BaseComponent from '../../../components/BaseComponent';
import { Item } from './Library';
import DimioSlidein from '../../../components/DimioSlidein';
import SearchKeyword from './SearchKeyword';
import SortPrice from './SortPrice';
import { isMobile, isBrowser } from 'react-device-detect';
//import Swipeable from 'react-swipeable';

import config from '../config/config';
import "../style/search.scss"

const { api } = config.travel;

/**
 * type: loader - loading item by NOI
 */
class ListPage extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { dispatch } = this.props;

    const opt = {
      query: {},
      onSuccess({ data, meta }) {
        //        console.info(data);
        dispatch({
          type: 'search/setSuggestions',
          items: data.suggestions,
        });
/*
        dispatch({
          type: 'search/sortPrice'
        });
        */
      },
      onError(error) {
        console.info(error);
      }
    }

    this.load(api.travelInfo, opt);

  }

  render() {
    const { search } = this.props;
    const { items, searchKeyword } = search;
    //    console.info(this.panel);

    if (this.panel) {
      if (items && items.size > 0) {
        this.panel.openPanel();
      }
    }

    return (
      <section className='travel-list'>
        <SearchKeyword />

        <DimioSlidein
          fromRight={true}
          closeButton={false}
          ref={(ref) => { this.panel = ref }}
        >
          {items &&
          <div>
            <div className='search-result-header py-3'>
              <div className='container'>
                <Row type="flex" gutter={8}>
                  <Col xs={6} lg={4}>
                    <Button
                      style={{ width: '100%', background: '#000', border: '1px solid #333' }}
                      onClick={this.panel.closePanel}
                      type='primary'>閉じる</Button>
                  </Col>
                  <Col xs={9} lg={16}>
                    {!isMobile &&
                    <SearchKeyword />
                    }
                  </Col>
                  <Col xs={9} lg={4}>
                    <SortPrice />
                  </Col>
                </Row>
                {isMobile &&
                <Row className='mt-2'>
                  <Col xs={24}>
                    <SearchKeyword />
                  </Col>
                </Row>
                }
              </div>
            </div>
            <hr />

            <div className='container'>
              <div className='row row-all-15'>
                {items.map((item, idx) => (
                  <div key={idx} className='col-lg-4'>
                    <Item item={item} />
                  </div>
                ))}
              </div>
            </div>
            {items && items.size == 0 &&
              <div className='select-city__alert'>
                検索に該当するものがありませんでした。<br />再検索してください。
              </div>
            }
          </div>
          }
        </DimioSlidein>

        {items && items.size == 0 &&
        <div className='select-city__alert'>
          検索に該当するものがありませんでした。<br />再検索してください。
        </div>
        }
      </section>
    );
  }
}

export default connect(({ search }) => ({
  search
}))(ListPage);



// WEBPACK FOOTER //
// ./src/pages/search/components/ListPage.js